
import Vue from "vue";
import { Component, Inject, Prop } from "vue-property-decorator";
import { RangeOptions } from "@/types/controls";
import { ElementStudioContext } from "./ElementStudioTabsAndPanels.vue";
import TextInput from "@/components/Reusable/CustomInputs/TextInput.vue";
import { parseFloatAndFixTo2Digits } from "@/util/math";

@Component({
  components: { TextInput }
})
export default class ElementStudioUnitOptions extends Vue {
  @Prop()
  value!: RangeOptions | null;

  get internalValue() {
    return this.value || { min: undefined, max: undefined, step: undefined };
  }

  @Inject("context") readonly context!: ElementStudioContext;

  get inputClass() {
    // same classes as TextInput
    return "d-flex breakdance-white-gray-outlined-input breakdance-simple-input breakdance-simple-input--text breakdance-simple-input--base";
  }

  updateStep(step: string) {
    this.emit({
      ...this.internalValue,
      step: step ? parseFloatAndFixTo2Digits(step) : undefined
    });
  }

  updateMin(min: string) {
    this.emit({
      ...this.internalValue,
      min: min ? parseInt(min) : undefined
    });
  }

  updateMax(max: string) {
    this.emit({
      ...this.internalValue,
      max: max ? parseInt(max) : undefined
    });
  }

  emit(rangeOptions: RangeOptions) {
    this.$emit("input", rangeOptions);
  }
}
